import React from 'react'
import {BrowserRouter as Router, Link} from "react-router-dom";

//import {UserContext} from '../../context/UserProvider'

const Header = () => {
    //const {user, iniciarSesion, cerrarSesion} = React.useContext(UserContext)

    return (
        <Router>
            <header>   	
                <div className="row">

                    <div className="top-bar">
                        <Link className="menu-toggle" to="#"><span>Menu</span></Link>

                        <div className="logo">
                            <Link to="/">MCROJASP</Link>
                        </div>		      

                        <nav id="main-nav-wrap">
                                <ul className="main-navigation">
                                    <li className="current"><Link to="#intro" className="smoothscroll" title="">Home</Link></li>
                                    <li><Link className="smoothscroll"  to="#about" title="">About</Link></li>
                                    <li><Link className="smoothscroll"  to="#resume" title="">Resume</Link></li>
                                    <li><Link className="smoothscroll"  to="#portfolio" title="">Portfolio</Link></li>					
                                    <li><Link className="smoothscroll"  to="#contact" title="">Contact</Link></li>
                                </ul>
                            </nav>    		
                    </div>
                    
                </div>
            </header>
        </Router>
    )
}

export default Header
